import ReactDOM from 'react-dom';

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import App from './App';
import reducers from "./reducers/index.js";

import './index.css';


/**
 * Required middleware for redux dev chrome tool
 * which is a fucking godsend btw
 */

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(reducers, /* preloadedState, */ composeEnhancers(applyMiddleware(thunk)));

if ("mediaSession" in navigator)
{
  navigator.mediaSession.metadata = new window.MediaMetadata({
    title: "",
    album: "",
    artist: ""
  })
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

